import type {
    GetAllGenericInfoResponseType
} from "./type";
import {
    request
} from "../request";

const getAllGenericInfo = async (): Promise<GetAllGenericInfoResponseType> => {
    return await request<GetAllGenericInfoResponseType>("/content/getAllGenericInfo", {
        method: "GET"
    });
};
export default getAllGenericInfo;
